const validate = (value, { target } = {}) => {
  if (!(value + '').length) return false
  if (!(target + '').length) return false
  const num1 = Number(value)
  const num2 = Number(target)
  // ГО для организатора и участника должно быть одинаковым
  return num1 === num2
}

export default {
  validate,
  params: ['target']
}
